import { render, staticRenderFns } from "./SecondNavbar.vue?vue&type=template&id=6527ab61&scoped=true"
import script from "./SecondNavbar.vue?vue&type=script&lang=ts"
export * from "./SecondNavbar.vue?vue&type=script&lang=ts"
import style0 from "./SecondNavbar.vue?vue&type=style&index=0&id=6527ab61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527ab61",
  null
  
)

export default component.exports